export const PROMO_ID_QUERYSTRING = 'uniquePromoId';
